import {
  Presentation,
  CalendarDays,
  Tag,
  Mail,
  BookMarked,
  Palette,
  Sparkles,
  type LucideIcon,
} from "lucide-react";

export type ResourceCategoryKey =
  | "ppt"
  | "thoi-khoa-bieu"
  | "nhan-vo"
  | "thu-moi-hop"
  | "bia-so"
  | "trang-tri"
  | "prompt-ai";

export interface ResourceCategory {
  key: ResourceCategoryKey;
  label: string;
  desc: string;
  icon: LucideIcon;
  /** Gradient nền cho icon nhóm + ảnh mockup. */
  grad: string;
}

/** Các nhóm tài nguyên đầu năm học. Thứ tự này quyết định thứ tự hiển thị. */
export const RESOURCE_CATEGORIES: ResourceCategory[] = [
  { key: "prompt-ai", label: "Mẫu Prompt AI", desc: "Câu lệnh mẫu tạo ảnh/nội dung — bấm dùng ngay với AI.", icon: Sparkles, grad: "from-cyan-400 to-indigo-600" },
  { key: "ppt", label: "Mẫu PowerPoint", desc: "Slide bài giảng, họp phụ huynh, trò chơi lớp học.", icon: Presentation, grad: "from-orange-400 to-red-500" },
  { key: "thoi-khoa-bieu", label: "Mẫu thời khóa biểu", desc: "Thời khóa biểu lớp học đẹp mắt, dễ chỉnh.", icon: CalendarDays, grad: "from-sky-400 to-blue-600" },
  { key: "nhan-vo", label: "Mẫu nhãn vở", desc: "Nhãn dán vở, đồ dùng cho học sinh.", icon: Tag, grad: "from-pink-400 to-rose-600" },
  { key: "thu-moi-hop", label: "Thư mời họp đầu năm", desc: "Mẫu thư mời phụ huynh họp đầu năm.", icon: Mail, grad: "from-violet-400 to-purple-600" },
  { key: "trang-tri", label: "Trang trí lớp học", desc: "Bảng biểu, góc học tập, khẩu hiệu.", icon: Palette, grad: "from-amber-400 to-orange-600" },
  { key: "bia-so", label: "Bìa sổ & kế hoạch", desc: "Bìa sổ chủ nhiệm, kế hoạch năm học.", icon: BookMarked, grad: "from-emerald-400 to-teal-600" },
];

export const RESOURCE_CATEGORY_KEYS = RESOURCE_CATEGORIES.map((c) => c.key);

export function getResourceCategory(key: string): ResourceCategory | undefined {
  return RESOURCE_CATEGORIES.find((c) => c.key === key);
}
